import { render, staticRenderFns } from "./MediaSpendAndReturn.vue?vue&type=template&id=48540288&scoped=true&"
import script from "./MediaSpendAndReturn.vue?vue&type=script&lang=js&"
export * from "./MediaSpendAndReturn.vue?vue&type=script&lang=js&"
import style0 from "./MediaSpendAndReturn.vue?vue&type=style&index=0&id=48540288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48540288",
  null
  
)

export default component.exports